"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 66: GxROM
 * ------------------------------------------------------------------ */
// GxROM

function register(Mappers) {
  Mappers[66] = function (nes) {
    this.nes = nes;
  };

  Mappers[66].prototype = new Mappers[0]();

  Mappers[66].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // GxROM (GNROM) switches the whole $8000-$FFFF range as one 32 KB bank:
    // bits 4-5 select the PRG bank, bits 0-1 the 8 KB CHR bank. Loading only a
    // 16 KB half left $C000 pointing at the last bank, so the far half of the
    // selected bank was never mapped and games (Dragon Ball) sat on a black
    // screen.
    this.load32kRomBank((value >> 4) & 0x03, 0x8000);
    this.load8kVromBank((value & 0x03) * 2, 0x0000);
  };

  Mappers[66].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("GxROM: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.load32kRomBank(0, 0x8000);
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
